import { memo } from 'react';

import { TableCell, TableRow } from '../ui';
import { DetectionGroupEventsTable } from './events/DetectionGroupEventsTable.js';

type DetectionGroupDetectionsRowProps = {
  deviceId: string;
  detectionGroupId: string;
  groupCreatedAt: string;
  detectionCount?: number;
  suppressionCount?: number;
  colSpan: number;
};

export const DetectionGroupDetectionsRow = memo(function DetectionGroupDetectionsRow({
  deviceId,
  detectionGroupId,
  groupCreatedAt,
  detectionCount,
  suppressionCount = 0,
  colSpan,
}: DetectionGroupDetectionsRowProps) {
  return (
    <TableRow data-group-detections-row>
      <TableCell colSpan={colSpan} className="bg-gray-light pl-8">
        <DetectionGroupEventsTable
          deviceId={deviceId}
          detectionGroupId={detectionGroupId}
          groupCreatedAt={groupCreatedAt}
          detectionCount={detectionCount}
          suppressionCount={suppressionCount}
        />
      </TableCell>
    </TableRow>
  );
});
